import { useMemo } from "react";
import {
	ClientPortfolioDomainEnum,
	type PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export type GroupedPortfolioList = Record<
	string,
	PortfolioListItemResponseDTO[]
>;

const GroupedPortfolioListOrder: (
	| ClientPortfolioDomainEnum
	| "Uncategorized"
)[] = [
	ClientPortfolioDomainEnum.LifeInsurance,
	ClientPortfolioDomainEnum.PropertyInsurance,
	ClientPortfolioDomainEnum.PensionProducts,
	ClientPortfolioDomainEnum.BuildingSavings,
	ClientPortfolioDomainEnum.Investments,
	ClientPortfolioDomainEnum.BusinessLoans,
	ClientPortfolioDomainEnum.Loans,
	ClientPortfolioDomainEnum.Leasing,
	ClientPortfolioDomainEnum.Commodities,
	ClientPortfolioDomainEnum.BankingProducts,
	ClientPortfolioDomainEnum.Cryptocurrencies,
	ClientPortfolioDomainEnum.Services,
	"Uncategorized",
];

export const useGroupPortfolio = (
	data: PortfolioListItemResponseDTO[],
): GroupedPortfolioList => {
	return useMemo(() => {
		const groupedData: GroupedPortfolioList = {};

		data.forEach((e) => {
			let key = e.domain || "Uncategorized";
			if (key === ClientPortfolioDomainEnum.PaidAdvisory) {
				key = ClientPortfolioDomainEnum.Services;
			}

			if (!groupedData[key]) {
				groupedData[key] = [];
			}
			groupedData[key].push(e);
		});

		const sortedKeys = Object.keys(groupedData).sort(
			(a, b) =>
				(GroupedPortfolioListOrder.indexOf(
					a as ClientPortfolioDomainEnum | "Uncategorized",
				) ?? 0) -
				(GroupedPortfolioListOrder.indexOf(
					b as ClientPortfolioDomainEnum | "Uncategorized",
				) ?? 0),
		);

		const sortedGroupedData: GroupedPortfolioList = {};

		sortedKeys.forEach((key) => {
			sortedGroupedData[key] = groupedData[key];
		});

		return sortedGroupedData;
	}, [data]);
};
